import { ErrorMessage } from 'nhsuk-react-components';

export interface ErrorsDisplayProps {
  errors: Record<string, string>;
  errorKeys: string[];
}

export function ErrorsDisplay({ errors, errorKeys }: ErrorsDisplayProps) {
  const hasErrors = errorKeys.some((key) => errors[key]);
  const firstError = errorKeys.find((key) => errors[key]);

  if (!hasErrors || !firstError) {
    return null;
  }

  return (
    <ErrorMessage>
      {errors[firstError]}
    </ErrorMessage>
  );
}
